import { render, staticRenderFns } from "./ClientsItem.vue?vue&type=template&id=697c3970&lang=pug&"
import script from "./ClientsItem.vue?vue&type=script&lang=js&"
export * from "./ClientsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports